module.exports = __webpack_public_path__ + "static/media/all.c5d65b24.svg";